import React from 'react';

import DataConnector from 'connect/DataConnector';
import {StringIDFolder} from 'constants/FolderConstants';
import * as NavConstants from 'constants/NavConstants';
import {getFolderListingURL} from 'nav/sidepanel/listing/SearchURLs';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as SidepanelReduxActions from 'nav/sidepanel/SidepanelReduxActions';
import SidepanelStore from 'nav/sidepanel/SidepanelStore';
import {SearchType} from 'search/SearchConstants';
import withSearching from 'search/withSearching';

import BioentityListing from './BioentityListing';
import RegistriesListing from './RegistriesListing';

interface RegistriesSidepanelProps {
  activeItemId: string | null;
  isCompactDisplay: boolean;
  setIsCompactDisplay: (isCompact: boolean) => void;
  isExpanded: boolean;
}
interface EnhancedProps {
  listedFolder: StringIDFolder | null;
  onListAllSources: () => void;
  onListSource: (rootFolder: StringIDFolder) => void;
}

class RegistriesSidepanelConnector extends DataConnector<RegistriesSidepanelProps, EnhancedProps> {
  stores = [SidepanelStore];

  onListSource = (rootFolder: StringIDFolder): void => {
    this.dispatch(SidepanelReduxActions.listFolder(rootFolder));
  };
  onListAllSources = (): void => {
    SidepanelActions.listAllSources(NavConstants.Section.REGISTRIES);
  };

  enhanceProps(): EnhancedProps {
    return {
      listedFolder: this.sidepanelStore().getListedFolder(NavConstants.Section.REGISTRIES),
      onListSource: this.onListSource,
      onListAllSources: this.onListAllSources,
    };
  }
}

const RegistryListing = withSearching(
  BioentityListing,
  SearchType.BIOENTITIES,
  NavConstants.Section.REGISTRIES,
  {getNavigationUpdate: getFolderListingURL}
);

export function RegistriesSidepanel(props: RegistriesSidepanelProps & EnhancedProps): JSX.Element {
  if (props.listedFolder == null) {
    return (
      <RegistriesListing
        isExpanded={props.isExpanded}
        onListSource={props.onListSource}
        sectionName="Registries"
      />
    );
  }
  return (
    <RegistryListing
      isCompactDisplay={props.isCompactDisplay}
      setIsCompactDisplay={props.setIsCompactDisplay}
      isExpanded={props.isExpanded}
      activeItemId={props.activeItemId}
      onNavigateToRoot={props.onListAllSources}
      folder={props.listedFolder}
    />
  );
}

export default RegistriesSidepanelConnector.connect(RegistriesSidepanel);
